import appCaptainVerification from "../../views/appSettings/captainVerificationView.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("captainverification", {
    url: "captains/verify",
    parent: "app",
    views: {
      view: {
        template: appCaptainVerification,
      },
    },
    reloadOnSearch: false,
    data: { title: "CaptainVerification" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/captainVerification/captainVerification.urls.js